import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["address", "propertyAddress", "propertyStatus"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { toJS } from 'mobx';
import { cast, getParent, types } from 'mobx-state-tree';
import { api } from 'src/api';
import { APPFOLIO_PROPERTY_STEPS, PROPERTY_STATUS_ENUM, PROPERTY_STEPS } from 'src/constants/property';
import { createAsync } from 'src/utils/asyncModel';
import { singleElementOfArray } from 'src/utils/singleElementOfArray';
import { generateAddressString } from 'src/utils/address';
const getPropertiesDashboardAsync = createAsync(body => {
  return async function getPropertiesDashboard(options) {
    const resp = await api.Properties.getPropertiesDashboard(body, options);
    this.assignActivePropertyList(resp.response);
    return resp;
  };
});
const getDashboardChartsAsync = createAsync(() => {
  return async function getDashboardCharts(options) {
    const resp = await api.Dashboard.getDashboardCarts(options);
    return resp;
  };
});
const createNewPropertyAsync = createAsync(body => {
  return async function createNewProperty(options) {
    const resp = await api.Properties.createNewProperty(body, options);
    getParent(this).addNewProperty.setPropertyInformation({
      propertyAddress: body.propertyAddress,
      ownership: body.ownership,
      buildingSquare: "".concat(body.buildings[0].buildingSquare)
    });
    localStorage.setItem('livable_property_id', resp.response);
    return resp;
  };
});
const updatePropertyAsync = createAsync(body => {
  return async function updateProperty(options) {
    const updateStore = body.updateStore === undefined ? true : body.updateStore;
    delete body.updateStore;
    const resp = await api.Properties.updateProperty(body, options);
    if (updateStore) getParent(this).addNewProperty.setPropertyInformation({
      propertyAddress: body.propertyAddress,
      ownership: body.ownership,
      buildingSquare: "".concat(body.buildings[0].buildingSquare)
    });
    return resp;
  };
});
const getResidenciesFeesAsync = createAsync(body => {
  return async function getResidenciesFees(options) {
    const resp = await api.Payment.getResidenciesFees(body, options);
    return resp;
  };
});
const setResidenciesFeesAsync = createAsync(body => {
  return async function setResidenciesFees(options) {
    const resp = await api.Payment.setResidenciesFees(body, options);
    return resp;
  };
});
const getPropertyFeesAsync = createAsync(_ref => {
  let body = _ref.body,
    _ref$isNotCompleted = _ref.isNotCompleted,
    isNotCompleted = _ref$isNotCompleted === void 0 ? false : _ref$isNotCompleted;
  return async function getPropertyFees(options) {
    const resp = await api.Properties.getPropertyFees(body, options);
    if (getParent(this).addNewProperty.completedStep === 0 || isNotCompleted) {
      getParent(this).addNewProperty.feeStructure.changeFeesAfterLoadData(resp.response);
    }
    return resp;
  };
});
const updatePropertyFeesAsync = createAsync(body => {
  return async function updatePropertyFees(options) {
    const resp = await api.Properties.updatePropertyFees(body, options);
    return resp;
  };
});
const getPropertysContactsAsync = createAsync(body => {
  return async function getPropertyContacts(options) {
    const resp = await api.Properties.getPropertyContacts(body, options);
    if (getParent(this).addNewProperty.completedStep === 0) {
      getParent(this).addNewProperty.setContactInfoAfterLoad(resp.response);
    }
    return resp;
  };
});
const updatePropertysContactsAsync = createAsync(body => {
  return async function updatePropertysContacts(options) {
    const resp = await api.Properties.updatePropertysContacts(body, options);
    return resp;
  };
});
const activatePropertyAsync = createAsync(body => {
  return async function activateProperty(options) {
    const resp = await api.Properties.activateProperty(body, options);
    return resp;
  };
});
const getPropertyAsync = createAsync(body => {
  return async function getProperty(options) {
    const resp = await api.Properties.getProperty(body, options);
    if (getParent(this).addNewProperty.completedStep === 0) {
      var _resp$response, _resp$response2, _resp$response3;
      getParent(this).addNewProperty.setPortfolioId(resp === null || resp === void 0 || (_resp$response = resp.response) === null || _resp$response === void 0 ? void 0 : _resp$response.portfolioId);
      getParent(this).addNewProperty.setPortfolioIds(resp === null || resp === void 0 || (_resp$response2 = resp.response) === null || _resp$response2 === void 0 ? void 0 : _resp$response2.portfolioIds);
      getParent(this).addNewProperty.setAccountAccess(resp === null || resp === void 0 || (_resp$response3 = resp.response) === null || _resp$response3 === void 0 || (_resp$response3 = _resp$response3.accountAccess) === null || _resp$response3 === void 0 ? void 0 : _resp$response3.accountIds);
      getParent(this).addNewProperty.setPropertyInformation({
        propertyAddress: generateAddressString(resp.response.address),
        ownership: resp.response.ownership,
        buildingSquare: "".concat(singleElementOfArray(resp.response.buildings).buildingSquare)
      });
    } else {
      getParent(this).addNewProperty.setPropertyInfo(resp.response);
    }
    return resp;
  };
});
const getPropertiesBatchAsync = createAsync(body => {
  return async function getPropertiesBatch(options) {
    const resp = await api.Properties.getPropertiesBatch(body, options);
    return resp;
  };
});
const deletePropertyAsync = createAsync(body => {
  return async function deleteProperty(options) {
    const resp = await api.Properties.deleteProperty(body, options);
    this.deletePropertyFromAllPropertyList(body.propertyId);
    return resp;
  };
});
const getPropertyUtilityProvidersV3Async = createAsync(body => {
  return async function getPropertyUtilityProvidersV3(options) {
    const resp = await api.Properties.getPropertyUtilityProvidersV3(body, options, true);

    // Refetching Utilities when navigating from Utility setup step 0, 5 and 6
    if ([0, PROPERTY_STEPS.UtilityConfiguration, PROPERTY_STEPS.UnitSetup, APPFOLIO_PROPERTY_STEPS.UtilityConfiguration, APPFOLIO_PROPERTY_STEPS.UnitSetup].includes(getParent(this).addNewProperty.completedStep) || !!(body !== null && body !== void 0 && body.forceSelectedUpdate)) {
      getParent(this).addNewProperty.utilitiesSetupV2.setUtilitiesInfoAfterLoad(resp.response);
    }
    const _getParent = getParent(this),
      properties = _getParent.properties;
    properties.setPropertyUtilitiesValueAfterLoad(resp);
    return resp;
  };
});
const deletePropertyUtilityProvidersAsync = createAsync(body => {
  return async function deletePropertyUtilityProviders(options) {
    const resp = await api.Properties.deletePropertyUtilityProvider(body, options);
    return resp;
  };
});
const getUnitUtilityProvidersAsync = createAsync(body => {
  return async function getUnitUtilityProviders(options) {
    const resp = await api.Properties.getUnitUtilityProviders(body, options, getParent(this).account.featureFlagsStore.getIsBillAutomationEnabled || getParent(this).account.featureFlagsStore.getIsBillingTemplatesEnabled);
    getParent(this).addNewProperty.utilitiesSetupV2.setUtilitiesInfoAfterLoad(resp.response);
    return resp;
  };
});
const getPropertySetupProgressAsync = createAsync(body => {
  return async function getPropertySetupProgress(options) {
    const resp = await api.Properties.getPropertySetupProgress(body, options);
    return resp;
  };
});
const getPropertyFeesV2Async = createAsync(body => {
  return async function getPropertyFeesV2(options) {
    const applyToStore = body.applyToStore,
      applyToHomeDashboard = body.applyToHomeDashboard;
    delete body.applyToStore;
    delete body.applyToHomeDashboard;
    const resp = await api.Payment.getPropertyFees(body, options);
    if (resp !== null && resp !== void 0 && resp.isSuccessful && resp !== null && resp !== void 0 && resp.response) {
      if (applyToStore) {
        const _getParent2 = getParent(this),
          feeStructureV2 = _getParent2.addNewProperty.feeStructureV2;
        feeStructureV2.applyFeesDataAfterFetch({
          data: resp.response
        });
        if (applyToHomeDashboard) {
          var _getParent$homeDashbo;
          (_getParent$homeDashbo = getParent(this).homeDashboardStore.getCurrentCompany) === null || _getParent$homeDashbo === void 0 || _getParent$homeDashbo.selectedPropertyDetails().details.feeSetup.applyFeesDataAfterFetch({
            data: resp.response
          });
        }
      }
    }
    return resp;
  };
});
const updatePropertyFeesV2Async = createAsync(body => {
  return async function updatePropertyFeesV2(options) {
    const resp = await api.Payment.updatePropertyFees(body, options);
    return resp;
  };
});
const updatePropertySetupProgressAsync = createAsync(body => {
  return async function updatePropertySetupProgress(options) {
    const resp = await api.Properties.updatePropertySetupProgress(body, options);
    return resp;
  };
});
const addPropertyUtilityProviderAsync = createAsync(_ref2 => {
  let propertyId = _ref2.propertyId,
    utilityProviderId = _ref2.utilityProviderId;
  return async function getProperty(options) {
    const resp = await api.Properties.addPropertyUtilityProvider({
      propertyId,
      utilityProviderId
    }, options);
    return resp;
  };
});
const addPropertyCommonAreaAmenityAsync = createAsync(_ref3 => {
  let propertyId = _ref3.propertyId,
    commonAreaAmenityId = _ref3.commonAreaAmenityId,
    commonAreaAmenityOptionId = _ref3.commonAreaAmenityOptionId,
    buildingIds = _ref3.buildingIds;
  return async function getProperty(options) {
    const resp = await api.Properties.addPropertyCommonAreaAmenity({
      propertyId,
      commonAreaAmenityId,
      commonAreaAmenityOptionId,
      buildingIds
    }, options);
    return resp;
  };
});
const getResidentTipsAsync = createAsync(() => {
  return async function getResidentTips(options) {
    const resp = await api.Properties.getResidentTips(options);
    if (resp && resp !== null && resp !== void 0 && resp.isSuccessful) getParent(this).properties.assignPropertyTipsList(resp.response);
    return resp;
  };
});
const getServerCurrentTimeAsync = createAsync(() => {
  return async function getServerCurrentTime(options) {
    const resp = await api.Properties.getServerCurrentTime(options);
    if (resp && resp !== null && resp !== void 0 && resp.isSuccessful) getParent(this).properties.setServerTime(resp.response);
    return resp;
  };
});
const ActivePropertyItem = types.model({
  id: types.string,
  propertyAddress: types.string
});
const AllPropertyItem = types.model({
  accountsReceivable: types.maybeNull(types.number),
  currentMonth: types.number,
  distributionForCurrentMonth: types.maybeNull(types.number),
  distributionForNextMonth: types.maybeNull(types.number),
  distributionForPreviousMonth: types.maybeNull(types.number),
  distributionToDate: types.maybeNull(types.number),
  enrollmentDate: types.maybeNull(types.string),
  nextMonth: types.number,
  overdueResidents: types.number,
  overdueResidentsCount: types.number,
  previousMonth: types.number,
  propertyAddress: types.string,
  propertyId: types.string,
  propertyStatus: types.string,
  recoveryPercentage: types.number,
  totalUtilityCostToDate: types.number,
  unitsEnrolled: types.number,
  unitsTotal: types.number,
  utilityCostRecoveryPriorMonth: types.number,
  utilityCostRecoveryToDate: types.number,
  isDemo: types.maybeNull(types.boolean)
});
const PortfolioPropertyItem = types.model({
  propertyId: types.string,
  propertyAddress: types.string,
  addressId: types.string,
  propertyStatus: types.string,
  enrollmentDate: types.maybeNull(types.string),
  unitsEnrolled: types.number,
  unitsTotal: types.number,
  totalUtilityCostToDate: types.number,
  utilityCostRecoveryToDate: types.number,
  utilityCostRecoveryPriorMonth: types.number,
  recoveryPercentage: types.maybeNull(types.number),
  accountsReceivable: types.maybeNull(types.number),
  previousMonth: types.number,
  distributionForCurrentMonth: types.maybeNull(types.number),
  currentMonth: types.number,
  distributionForNextMonth: types.maybeNull(types.maybeNull(types.number)),
  nextMonth: types.number,
  distributionToDate: types.maybeNull(types.number),
  isDemo: types.boolean,
  utilities: types.optional(types.array(types.string), []),
  utilityCount: types.number
});
const ActivePortfolioItem = types.model({
  id: types.string,
  name: types.string,
  properties: types.optional(types.array(PortfolioPropertyItem), [])
});
const propertyTips = types.model({
  id: types.string,
  tip: types.string
});
const propertyUtility = types.model({
  allocationMethod: types.string,
  billFrequencyType: types.string,
  buildingIds: types.optional(types.array(types.string), []),
  commonAreaDeduction: types.number,
  goodWillDeduction: types.maybeNull(types.number),
  isCustom: types.maybeNull(types.boolean),
  name: types.optional(types.string, ''),
  utilityId: types.string,
  propertyUtilityId: types.string,
  vacantUnitAllocation: types.string,
  vacantUnitUsage: types.string,
  vacantUnitUsageLimit: types.maybeNull(types.number)
});
const PropertiesStore = types.model('PropertiesStore', {
  getPropertyUtilityProvidersV3Async,
  updatePropertysContactsAsync,
  getPropertiesDashboardAsync,
  getPropertysContactsAsync,
  updatePropertyFeesAsync,
  getDashboardChartsAsync,
  createNewPropertyAsync,
  activatePropertyAsync,
  getPropertyFeesAsync,
  deletePropertyAsync,
  updatePropertyAsync,
  getPropertyAsync,
  getPropertiesBatchAsync,
  getPropertySetupProgressAsync,
  updatePropertySetupProgressAsync,
  getUnitUtilityProvidersAsync,
  addPropertyUtilityProviderAsync,
  deletePropertyUtilityProvidersAsync,
  addPropertyCommonAreaAmenityAsync,
  getPropertyFeesV2Async,
  updatePropertyFeesV2Async,
  getResidentTipsAsync,
  getServerCurrentTimeAsync,
  getResidenciesFeesAsync,
  setResidenciesFeesAsync,
  activePropertyList: types.optional(types.array(ActivePropertyItem), []),
  activePortfolioList: types.optional(types.array(ActivePortfolioItem), []),
  allPropertyList: types.optional(types.array(AllPropertyItem), []),
  propertyTipsList: types.optional(types.array(propertyTips), []),
  propertyUtilitiesValue: types.optional(types.array(propertyUtility), []),
  serverTime: types.maybeNull(types.model({
    utcTime: types.maybeNull(types.string),
    businessDateOnly: types.maybeNull(types.string)
  }))
}).actions(store => ({
  setServerTime(data) {
    try {
      store.serverTime = data;
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  assignActivePropertyList(data) {
    try {
      store.activePropertyList = cast([]);
      store.allPropertyList = cast([]);
      data.map(item => {
        const address = item.address,
          propertyAddress = item.propertyAddress,
          propertyStatus = item.propertyStatus,
          itemData = _objectWithoutProperties(item, _excluded);
        store.allPropertyList.push(_objectSpread(_objectSpread({}, itemData), {}, {
          propertyStatus: PROPERTY_STATUS_ENUM[propertyStatus],
          propertyAddress: generateAddressString(address)
        }));
        if (PROPERTY_STATUS_ENUM[propertyStatus] === 'Active') {
          store.activePropertyList.push({
            id: item.propertyId,
            propertyAddress: generateAddressString(address)
          });
        }
      });
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  deletePropertyFromAllPropertyList(data) {
    try {
      const propertyIndex = store.allPropertyList.findIndex(item => item.propertyId === data);
      store.allPropertyList.splice(propertyIndex, 1);
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  assignPropertyTipsList(data) {
    try {
      store.propertyTipsList = cast([]);
      data.map(item => {
        store.propertyTipsList.push({
          id: item.id,
          tip: item.tip
        });
      });
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  setPropertyUtilitiesValueAfterLoad(resp) {
    try {
      store.propertyUtilitiesValue = cast([]);
      resp.response.map(item => {
        item.utilities.map(u => {
          store.propertyUtilitiesValue.push(_objectSpread(_objectSpread({}, u), {}, {
            name: u.utilityType,
            propertyUtilityId: u.id
          }));
        });
      });
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  }
  // setActivePortfolioItemsAfterLoad(data) {
  //   try {
  //     store.activePortfolioList = cast([]);
  //     store.activePortfolioList = data;
  //   } catch (error) {
  //     console.error('STORE ERROR > setActivePortfolioItemsAfterLoad', error);
  //   }
  // },
})).views(store => ({
  get first() {
    return toJS(store.allPropertyList[0]);
  },
  get propertyUtilities() {
    return toJS(store.propertyUtilitiesValue);
  },
  propertyById(id) {
    return toJS(store.allPropertyList.find(item => item.propertyId === id));
  },
  // NOTE: Not use right now
  // propertiesByPortfolio(id) {
  //   return toJS(store.activePortfolioList.find(portfolio => portfolio.id === id)?.properties);
  // },
  // get portfoliosWithActiveProperties() {
  //   return toJS(
  //     store.activePortfolioList.filter(
  //       portfolio => portfolio.properties.filter(p => p.propertyStatus === PROPERTY_STATUS_ENUM.Active)?.length >= 1
  //     )
  //   );
  // },
  activePropertiesByPortfolio(id) {
    var _store$activePortfoli;
    return toJS((_store$activePortfoli = store.activePortfolioList.find(portfolio => portfolio.id === id)) === null || _store$activePortfoli === void 0 ? void 0 : _store$activePortfoli.properties.filter(p => p.propertyStatus === PROPERTY_STATUS_ENUM.Active));
  },
  get serverUtcTime() {
    return store.serverTime.utcTime;
  },
  get serverBusinessDateOnly() {
    return store.serverTime.businessDateOnly;
  }
}));
export const properties = types.optional(PropertiesStore, {});